import useSWR from 'swr';
import { useMemo } from 'react';

import { httpGet } from 'src/utils/cms-axios';

import { saveAdminConfig } from './admin-config-save';

export async function getPostSummaryAdminConfig(site_id, post_type_id) {
    const res = await httpGet("/post-summary-admin-config", {
        "post_type_id": post_type_id,
    }, { "cms-site-id": site_id }, "/config-api");
    return res;
}

// base_version: 開いたときの保存版トークン（GET の version）。undefined なら照合しない
// （admin-config-save.js）。
export function updatePostSummaryAdminConfig(data) {
    const { site_id, post_type_id, settings, base_version } = data;
    return saveAdminConfig(
        `/post-summary-admin-config?post_type_id=${post_type_id}`, settings, site_id, base_version);
}

export function useGetPostSummaryAdminConfig(site_id, post_type_id) {
    const { data, isLoading, isError, isValidating, mutate, error } = useSWR(
        site_id && post_type_id ? ['/config-api/post-summary-admin-config', site_id, post_type_id] : null,
        () => getPostSummaryAdminConfig(site_id, post_type_id)
    );

    const memoizedValue = useMemo(
        () => ({
            configData: data || null,
            configLoading: isLoading,
            configError: error,
            configValidating: isValidating,
            configRefresh: mutate,
        }),
        [data, error, isLoading, isValidating, mutate]
    );

    return memoizedValue;
}
